import React from 'react';
import { Smartphone, Shield, ArrowRight } from 'lucide-react';

export default function MobileAppPage() {
  const installPWA = (type) => {
    // Switch manifest and prompt install
    if (type === 'full') {
      // Update manifest link to full app
      const link = document.querySelector('link[rel="manifest"]');
      if (link) link.href = '/manifest-full.json';
    }
    // Show install instructions
    alert(
      type === 'full'
        ? 'For å installere full app:\n\n1. Åpne denne siden i nettleseren\n2. Trykk på "Del"-ikonet (iOS) eller menyen (Android)\n3. Velg "Legg til på hjemskjerm"\n\nAppen vil fungere som en vanlig app med full funksjonalitet.'
        : 'For å installere RUH-appen:\n\n1. Gå til /m/ruh i nettleseren\n2. Trykk på "Del"-ikonet (iOS) eller menyen (Android)\n3. Velg "Legg til på hjemskjerm"\n\nRUH-appen er optimalisert for rask registrering av hendelser.'
    );
  };

  return (
    <div className="min-h-screen bg-slate-950 flex items-center justify-center p-4">
      <div className="max-w-lg w-full space-y-6">
        <div className="text-center mb-8">
          <div className="w-16 h-16 bg-cyan-500/10 rounded-2xl flex items-center justify-center mx-auto mb-4">
            <Smartphone className="w-8 h-8 text-cyan-400" />
          </div>
          <h1 className="text-2xl font-bold text-white mb-2">Installer Systemklar</h1>
          <p className="text-slate-400">Velg hvilken versjon du vil installere på din enhet.</p>
        </div>

        {/* Full App */}
        <button
          onClick={() => installPWA('full')}
          className="w-full bg-slate-900/80 border border-slate-800/60 rounded-2xl p-6 text-left hover:border-cyan-500/40 transition-all group"
          data-testid="install-full-app"
        >
          <div className="flex items-start justify-between">
            <div className="flex-1">
              <div className="flex items-center gap-2 mb-2">
                <h2 className="text-lg font-semibold text-white">Systemklar - Full app</h2>
                <span className="px-2 py-0.5 text-xs bg-cyan-500/20 text-cyan-400 rounded-full">Anbefalt</span>
              </div>
              <p className="text-sm text-slate-400 mb-3">
                Komplett HMS-verktøy med dashboard, oppgaver, saker, rapporter og analyse.
              </p>
              <ul className="text-xs text-slate-500 space-y-1">
                <li>Dashboard med oversikt</li>
                <li>Oppgaver og saker</li>
                <li>Rapporter og analyse</li>
                <li>Push-varsler</li>
                <li>AI-dokumentgenerering</li>
              </ul>
            </div>
            <ArrowRight className="w-5 h-5 text-slate-600 group-hover:text-cyan-400 transition-colors mt-1" />
          </div>
        </button>

        {/* RUH Only */}
        <button
          onClick={() => installPWA('ruh')}
          className="w-full bg-slate-900/80 border border-slate-800/60 rounded-2xl p-6 text-left hover:border-emerald-500/40 transition-all group"
          data-testid="install-ruh-app"
        >
          <div className="flex items-start justify-between">
            <div className="flex-1">
              <div className="flex items-center gap-2 mb-2">
                <h2 className="text-lg font-semibold text-white">RUH - Rask registrering</h2>
                <span className="px-2 py-0.5 text-xs bg-emerald-500/20 text-emerald-400 rounded-full">Enkel</span>
              </div>
              <p className="text-sm text-slate-400 mb-3">
                Optimalisert for rask registrering av uønskede hendelser. Fungerer offline.
              </p>
              <ul className="text-xs text-slate-500 space-y-1">
                <li>Registrer hendelser raskt</li>
                <li>Offline-støtte</li>
                <li>Minimal og fokusert</li>
              </ul>
            </div>
            <ArrowRight className="w-5 h-5 text-slate-600 group-hover:text-emerald-400 transition-colors mt-1" />
          </div>
        </button>

        {/* Info */}
        <div className="text-center">
          <p className="text-xs text-slate-600">
            Begge versjoner installeres fra nettleseren — ingen App Store nødvendig.
          </p>
        </div>
      </div>
    </div>
  );
}
